<template>
    <div>
        <div class="timeline-controls">
<!--            <div class="mini-timeline">-->
<!--                <div class="selected-range">-->
<!--                </div>-->
<!--            </div>-->
<!--            <button type="button" class="btn" v-on:click="rangeChanged()">Test button to set range</button>-->
            <div class="zoom-controls">
                <button type="button" class="" v-on:click="zoomIn()" :aria-label="t('timeline.zoom.in')">
                    <font-awesome-icon :icon="['fas', 'search-plus']" aria-hidden="true" role="presentation" />
                </button>
                <button type="button" class="" v-on:click="zoomOut()" :aria-label="t('timeline.zoom.out')">
                    <font-awesome-icon :icon="['fas', 'search-minus']" aria-hidden="true" role="presentation" />
                </button>
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
    export default {
        methods: {
            zoomIn() {
                this.$emit('zoomIn');
            },
            zoomOut() {
                this.$emit('zoomOut');
            },
            setRange(/*start, end*/) {
                // Asetetaan tässä tämän komponentin näyttämä range parametrina saatuihin arvoihin
                //console.log("Setting range " + start + " - " + end);
            },
            rangeChanged() {
                const start = new Date(2021, 1, 1, 0, 0, 0);
                const end = new Date(2022, 1, 1, 0, 0, 0);

                this.$emit('rangeChange', {start: start, end: end});
            }
        }
    }
</script>

<style lang="scss">
    .aui .portlet-hankeikkuna-government-timeline, .portlet-hankeikkuna-government-timeline {
        $black : #222;
        $lightgray : #f0f0f0;
        $gray : #979797;
        $darkgray : #505050;
        $lightblue : #DFE7F5;
        $blue : #365abd;

        .clear {
            clear: both;
        }

        .timeline-controls {
            float: right;
            margin: 15px;

            .mini-timeline {
                width: 200px;

                .selected-range {
                    background-color: #4a148c;
                    opacity: 0.5;
                }
            }

            .zoom-controls {
                text-align: right;

                button {
                    background: none;
                    border: 0;
                    padding: 0;
                    box-shadow: none;
                    color: $blue;
                    font-size: 25px;
                    margin: 0 0 0 25px;
                }
            }
        }
    }
</style>